Foundation.Mobile.Cal = function (trigger, dropdown, carousel) {
    var owl_options = {
        items : 2,
        itemsCustom : false,
        itemsDesktop : [1199, 2],
        itemsDesktopSmall : [980, 2],
        itemsTablet: [768, 2],
        itemsTabletSmall: [600, 1],
        itemsMobile : [479, 1],
        singleItem : false,
        itemsScaleUp : false,
        autoHeight:true,
        responsiveBaseWidth : '.ui.content'
    };

    var car = jQuery(carousel).owlCarousel(owl_options);

    jQuery(trigger).click(function () {
        car.data('owlCarousel').updateVars();
        jQuery(dropdown).toggle('fast', function () {
            /*noop*/
        });
    });
}



